import {
  AdminReviewStatus,
  type ChangeFieldRequest,
  DataConfirmationStatus,
  type EmployeeRequestedDataChange
} from 'src/old/api/dataChangeRequests/types';

export const byPendingReview = (employee: EmployeeRequestedDataChange): boolean =>
  employee?.dataConfirmationStatus === DataConfirmationStatus.PENDING_REVIEW;

const findRequestIndexToUpdate = (sourceRequests: EmployeeRequestedDataChange[], requestIdToUpdate: number) =>
  sourceRequests.findIndex(({ id }: { id: number }): boolean => id === requestIdToUpdate);

export const updateRequests = (
  sourceRequests: EmployeeRequestedDataChange[],
  updatedRequest: EmployeeRequestedDataChange
) => {
  const requestIndexToUpdate = findRequestIndexToUpdate(sourceRequests, updatedRequest.id);
  const sourceRequestsCopy = [...sourceRequests];

  const maybeNewPersonalId = updatedRequest.dataConfirmation.changesRequested.find(
    (changeFieldRequest: ChangeFieldRequest) => {
      const { fieldName, adminReviewStatus } = changeFieldRequest;

      return fieldName === 'personalId' && adminReviewStatus === AdminReviewStatus.ACCEPTED;
    }
  );

  if (maybeNewPersonalId) {
    sourceRequestsCopy[requestIndexToUpdate].personalId = maybeNewPersonalId.newValue;
  }

  sourceRequestsCopy[requestIndexToUpdate].dataConfirmationStatus = DataConfirmationStatus.ADMIN_APPROVED;
  sourceRequestsCopy[requestIndexToUpdate].dataConfirmation.changesRequested =
    updatedRequest.dataConfirmation.changesRequested;

  return sourceRequestsCopy;
};
